import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { CartProvider } from './hooks/useCart';
import { ToastProvider } from './hooks/useToast';
// Admin Pages
import { Dashboard } from './pages/Dashboard';
import { PopUpStores } from './pages/PopUpStores';
import { PopUpStoreNew } from './pages/PopUpStoreNew';
import { PopUpStoreDetail } from './pages/PopUpStoreDetail';
import { Orders } from './pages/Orders';
import { OrderDetail } from './pages/OrderDetail';
import { PackingSlip } from './pages/orders/PackingSlip';
import { Fulfillment } from './pages/Fulfillment';
import { Organizations } from './pages/Organizations';
import { OrganizationDetail } from './pages/OrganizationDetail';
import { Search } from './pages/Search';
// Storefront Pages
import { Storefront } from './pages/storefront/Storefront';
import { ProductDetail } from './pages/storefront/ProductDetail';
import { Cart } from './pages/storefront/Cart';
import { Checkout } from './pages/storefront/Checkout';
export function App() {
  return <ToastProvider data-id="element-0">
      <CartProvider data-id="element-1">
        <Router data-id="element-2">
          <Routes data-id="element-3">
            {/* Admin Routes (with Layout) */}
            <Route path="/" element={<Layout data-id="element-5">
                  <Dashboard data-id="element-6" />
                </Layout>} data-id="element-4" />
            <Route path="/pop-up-stores" element={<Layout data-id="element-8">
                  <PopUpStores data-id="element-9" />
                </Layout>} data-id="element-7" />
            <Route path="/pop-up-stores/new" element={<Layout data-id="element-11">
                  <PopUpStoreNew data-id="element-12" />
                </Layout>} data-id="element-10" />
            <Route path="/pop-up-stores/:id" element={<Layout data-id="element-14">
                  <PopUpStoreDetail data-id="element-15" />
                </Layout>} data-id="element-13" />
            <Route path="/orders" element={<Layout data-id="element-17">
                  <Orders data-id="element-18" />
                </Layout>} data-id="element-16" />
            <Route path="/orders/:id" element={<Layout data-id="element-20">
                  <OrderDetail data-id="element-21" />
                </Layout>} data-id="element-19" />
            <Route path="/orders/:id/packing-slip" element={<PackingSlip data-id="element-23" />} data-id="element-22" />
            <Route path="/fulfillment" element={<Layout data-id="element-25">
                  <Fulfillment data-id="element-26" />
                </Layout>} data-id="element-24" />
            <Route path="/organizations" element={<Layout data-id="element-28">
                  <Organizations data-id="element-29" />
                </Layout>} data-id="element-27" />
            <Route path="/organizations/:id" element={<Layout data-id="element-31">
                  <OrganizationDetail data-id="element-32" />
                </Layout>} data-id="element-30" />
            <Route path="/search" element={<Layout data-id="element-34">
                  <Search data-id="element-35" />
                </Layout>} data-id="element-33" />
            <Route path="/settings" element={<Layout data-id="element-37">
                  <div className="p-4" data-id="element-38">Settings Page Placeholder</div>
                </Layout>} data-id="element-36" />

            {/* Storefront Routes (no admin Layout) */}
            <Route path="/store/:slug" element={<Storefront data-id="element-40" />} data-id="element-39" />
            <Route path="/store/:slug/products/:productId" element={<ProductDetail data-id="element-42" />} data-id="element-41" />
            <Route path="/store/:slug/cart" element={<Cart data-id="element-44" />} data-id="element-43" />
            <Route path="/store/:slug/checkout" element={<Checkout data-id="element-46" />} data-id="element-45" />
          </Routes>
        </Router>
      </CartProvider>
    </ToastProvider>;
}